var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: `城市仓${_vm.titles}`,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents" },
            [
              _c(
                "el-form",
                {
                  ref: "refCityForm",
                  staticClass: "demo-cityForm",
                  attrs: {
                    "label-width": "100px",
                    model: _vm.cityForm,
                    rules: _vm.cityRules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "城市仓名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: true,
                          placeholder: "请输入城市仓名称",
                          clearable: "",
                        },
                        model: {
                          value: _vm.cityForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.cityForm, "name", $$v)
                          },
                          expression: "cityForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "主体性质", prop: "certification_type" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.cityForm.certification_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.cityForm, "certification_type", $$v)
                            },
                            expression: "cityForm.certification_type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 10 } }, [
                            _vm._v("个人"),
                          ]),
                          _c("el-radio", { attrs: { label: 20 } }, [
                            _vm._v("个体工商户"),
                          ]),
                          _c("el-radio", { attrs: { label: 30 } }, [
                            _vm._v("企业"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.cityForm.certification_type == 20
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "绑卡类型",
                            required: _vm.cityForm.certification_type == 20,
                            prop: "account_type",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.cityForm.account_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "account_type", $$v)
                                },
                                expression: "cityForm.account_type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 10 } }, [
                                _vm._v("个人"),
                              ]),
                              _c("el-radio", { attrs: { label: 30 } }, [
                                _vm._v("企业"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.cityForm.certification_type != 10
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "营业执照", prop: "license_img" },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  class: {
                                    hide:
                                      _vm.license_img.length ||
                                      !_vm.license_img,
                                  },
                                  attrs: {
                                    action: _vm.httpurl,
                                    "on-preview":
                                      _vm.onHandlePictureCardPreview,
                                    "file-list": _vm.license_img,
                                    headers: { token: _vm.token },
                                    "list-type": "picture-card",
                                    "on-success": _vm.onsuccess,
                                    "before-remove": () =>
                                      _vm.onHandleDeleteFile("license_img"),
                                    limit: 1,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-plus",
                                    attrs: { slot: "trigger" },
                                    slot: "trigger",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "主体名称",
                                prop: "register_name",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入主体名称",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.register_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "register_name", $$v)
                                  },
                                  expression: "cityForm.register_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "统一社会信用代码",
                                prop: "uscc",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入统一社会信用代码",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.uscc,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "uscc", $$v)
                                  },
                                  expression: "cityForm.uscc",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.cityForm.certification_type == 30
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "企业联系电话",
                                    prop: "company_mobile",
                                    required:
                                      _vm.cityForm.certification_type == 30,
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入企业联系电话",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.cityForm.company_mobile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.cityForm,
                                          "company_mobile",
                                          $$v
                                        )
                                      },
                                      expression: "cityForm.company_mobile",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "持卡人身份证国徽页图片",
                            prop: "id_card_a_img",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              class: {
                                hide:
                                  _vm.id_card_a_img.length ||
                                  !_vm.id_card_a_img,
                              },
                              attrs: {
                                action: "#",
                                "on-preview": _vm.onHandlePictureCardPreview,
                                "file-list": _vm.id_card_a_img,
                                "list-type": "picture-card",
                                "http-request": (data) =>
                                  _vm.onHandleUploadFile(data, "id_card_a_img"),
                                "before-remove": () =>
                                  _vm.onHandleDeleteFile("id_card_a_img"),
                                limit: 1,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "trigger" },
                                slot: "trigger",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "持卡人身份证人像页图片",
                            prop: "id_card_b_img",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              class: {
                                hide:
                                  _vm.id_card_b_img.length ||
                                  !_vm.id_card_b_img,
                              },
                              attrs: {
                                action: "#",
                                "on-preview": _vm.onHandlePictureCardPreview,
                                "file-list": _vm.id_card_b_img,
                                "list-type": "picture-card",
                                "http-request": (data) =>
                                  _vm.onHandleUploadFile(data, "id_card_b_img"),
                                "before-remove": () =>
                                  _vm.onHandleDeleteFile("id_card_b_img"),
                                limit: 1,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "trigger" },
                                slot: "trigger",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.cityForm.certification_type == 10
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "姓名", prop: "manage_name" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入姓名",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.manage_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "manage_name", $$v)
                                  },
                                  expression: "cityForm.manage_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "身份证号码",
                                prop: "id_card_code",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入身份证号码",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.id_card_code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "id_card_code", $$v)
                                  },
                                  expression: "cityForm.id_card_code",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "电话", prop: "manage_mobile" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入电话",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.manage_mobile,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "manage_mobile", $$v)
                                  },
                                  expression: "cityForm.manage_mobile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.cityForm.certification_type != 10
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "法人姓名", prop: "manage_name" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入法人姓名",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.manage_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "manage_name", $$v)
                                  },
                                  expression: "cityForm.manage_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "身份证号",
                                prop: "id_card_code",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入身份证号",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.id_card_code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "id_card_code", $$v)
                                  },
                                  expression: "cityForm.id_card_code",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "法人电话",
                                prop: "manage_mobile",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入法人电话",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.manage_mobile,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "manage_mobile", $$v)
                                  },
                                  expression: "cityForm.manage_mobile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }